import { motion } from 'framer-motion';
import { Car, Bus, MapPin, Clock, Fuel, Navigation } from 'lucide-react';

export default function HowToGetThere() {
  return (
    <div className="min-h-screen bg-ff-blue pt-20" data-testid="how-to-get-there-page">
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <span className="badge mb-4">
              Event Details
            </span>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl text-ff-brown">
              How To <span className="text-ff-brown">Get There</span>
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-8 mb-8">
              <div className="flex items-center gap-4 mb-6">
                <MapPin className="w-8 h-8 text-ff-brown" />
                <h2 className="font-display text-2xl text-ff-brown">Location Details</h2>
              </div>
              <p className="text-ff-brown/70">
                Frequency Forest is held at <strong className="text-ff-brown">Maitland Showground</strong>, NSW.
                It's the exact location — you can't get more specific than that! Simply set your maps
                to Maitland Showground and you're on your way.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-6">
                <Car className="w-6 h-6 text-ff-brown mb-4" />
                <h3 className="font-display text-xl text-ff-brown mb-3">By Car</h3>
                <p className="text-ff-brown/70 text-sm mb-4">
                  Driving is the most common way to reach Frequency Forest. The venue is 
                  accessible via sealed roads, with a short gravel section near the entrance.
                </p>
                <ul className="text-ff-brown/70 text-sm space-y-1">
                  <li>• Free on-site parking included</li>
                  <li>• Carpooling encouraged</li>
                  <li>• Download offline maps before arrival</li>
                </ul>
              </div>
              
              <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-6">
                <Bus className="w-6 h-6 text-ff-brown mb-4" />
                <h3 className="font-display text-xl text-ff-brown mb-3">Shuttle Service</h3>
                <p className="text-ff-brown/70 text-sm mb-4">
                  We're working on a shuttle service from Sydney. Check back closer to the event
                  for updates on organised transport.
                </p>
                <ul className="text-ff-brown/70 text-sm space-y-1">
                  <li>• Sydney shuttle – details coming soon</li>
                </ul>
              </div>
            </div>

            <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-8 mb-8">
              <div className="flex items-center gap-4 mb-6">
                <Clock className="w-6 h-6 text-ff-brown" />
                <h3 className="font-display text-xl text-ff-brown">Approximate Travel Times</h3>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="flex justify-between py-2 border-b border-ff-outline/20">
                  <span className="text-ff-brown/70">From Sydney</span>
                  <span className="text-ff-brown">~2.5 hours</span>
                </div>
                <div className="flex justify-between py-2 border-b border-ff-outline/20">
                  <span className="text-ff-brown/70">From Newcastle</span>
                  <span className="text-ff-brown">~30 minutes</span>
                </div>
              </div>
            </div>

            <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-8">
              <div className="flex items-center gap-4 mb-6">
                <Fuel className="w-6 h-6 text-ff-brown" />
                <h3 className="font-display text-xl text-ff-brown">Before You Leave</h3>
              </div>
              <ul className="text-ff-brown/70 space-y-2">
                <li>• Fill up your tank before you set off</li>
                <li>• Download your ticket for offline access</li>
                <li>• Plan your arrival – gates open Thursday afternoon for early access pass holders only</li>
                <li>• Strict gate timings apply</li>
              </ul>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
